import { ChoicesAnswer, ObjectId } from '../../components/context/SurveyPageContext';

interface BuildChoicesAnswer {
  questionId: number;
  choices: ObjectId[];
}

const buildChoicesAnswer = ({ questionId, choices }: BuildChoicesAnswer): ChoicesAnswer => ({
  question: { id: questionId },
  choices,
});

export { buildChoicesAnswer };
